import { AccountT, AccountUpdateRequestT } from '../../types';
import { addressTransform } from '../address/address';
import { incomeTransform } from '../income/income';
import { serializeMaritalInformation } from '../marital-information/serialize-marital-information';

export const serializeAccount = (account: AccountT): AccountUpdateRequestT => {
  const address = account.address && addressTransform.serialize(account.address);
  const income = account.income && incomeTransform.serialize(account.income);
  const maritalInformation = account.maritalInformation && serializeMaritalInformation(account.maritalInformation);

  return {
    ...address,
    ...income,
    ...maritalInformation,
    main_phone: account.phoneNumber,
  };
};
